(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lgb-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lgb-pillow-gallery'))customElements.define('lgb-pillow-gallery',class extends HTMLElement{
  connectedCallback(){
    if(this.dataset.ready)return;
    this.dataset.ready='true';
    this.addEventListener('click',event=>{
      const button=event.target.closest('[data-lgb-src]');
      if(!button||!this.contains(button))return;
      const photo=this.querySelector('[data-lgb-image]');
      if(!photo)return;
      photo.removeAttribute('srcset');
      photo.src=button.dataset.lgbSrc;
      photo.alt=button.dataset.lgbAlt;
      this.querySelectorAll('[data-lgb-src]').forEach(item=>item.setAttribute('aria-current',String(item===button)));
    });
  }
});

function lgbInitSticky(root){
  root.querySelectorAll('[data-lgb-sticky]').forEach(bar=>{
    if(bar.dataset.ready)return;
    const section=bar.closest('.lgb-product');
    if(!section||!('IntersectionObserver' in window))return;
    bar.dataset.ready='true';
    const observer=new IntersectionObserver(entries=>{
      const entry=entries[0];
      bar.hidden=entry.isIntersecting||entry.boundingClientRect.top>0;
    },{threshold:0});
    observer.observe(section);
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>lgbInitSticky(document));else lgbInitSticky(document);
document.addEventListener('shopify:section:load',event=>lgbInitSticky(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lgb-storefront"] && !Shopify.designMode) return;
  try {
    
const updateVariantPhoto=input=>{const form=input.closest('form');const label=input.closest('fieldset').querySelector('legend strong');if(label)label.textContent=input.dataset.colourTitle;const gallery=form.closest('.lg2-pdp').querySelector('lg2-gallery');const image=gallery?.querySelector('[data-lg2-main]');if(!image||!input.dataset.variantImage)return;image.removeAttribute('srcset');image.src=input.dataset.variantImage;image.alt=input.dataset.variantAlt;gallery.querySelectorAll('[data-lg2-src]').forEach(button=>button.setAttribute('aria-current','false'));};document.addEventListener('change',event=>{const input=event.target;if(!input.matches('.lgb-swatches input[data-colour-title]'))return;updateVariantPhoto(input);});document.querySelectorAll('.lgb-swatches input[data-colour-title]:checked').forEach(updateVariantPhoto);

if(!customElements.get('lg2-gallery'))customElements.define('lg2-gallery',class extends HTMLElement{
connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.addEventListener('click',event=>{const btn=event.target.closest('[data-lg2-src]');if(!btn)return;const img=this.querySelector('[data-lg2-main]');img.removeAttribute('srcset');img.src=btn.dataset.lg2Src;img.alt=btn.dataset.lg2Alt;this.querySelectorAll('[data-lg2-src]').forEach(b=>b.setAttribute('aria-current',String(b===btn)));});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
